import { api } from '../../../../lib/api';

/**
 * Cliente API para equipos de trabajo (/api/labor/teams).
 */
export const teamService = {
  async getTeams() {
    const data = await api.get('/api/labor/teams');
    return Array.isArray(data) ? data : (data?.data || []);
  },

  async getTeamById(teamId) {
    return api.get(`/api/labor/teams/${teamId}`);
  },

  async createTeam(teamData) {
    return api.post('/api/labor/teams', teamData);
  },

  async updateTeam(teamId, teamData) {
    return api.put(`/api/labor/teams/${teamId}`, teamData);
  },

  async deleteTeam(teamId) {
    return api.delete(`/api/labor/teams/${teamId}`);
  },

  async getTeamMembers(teamId) {
    const data = await api.get(`/api/labor/teams/${teamId}/members`);
    return Array.isArray(data) ? data : (data?.members || []);
  },

  async addTeamMember(teamId, { employeeId, startDate }) {
    return api.post(`/api/labor/teams/${teamId}/members`, {
      team_id: Number(teamId),
      employee_id: Number(employeeId),
      start_date: startDate,
    });
  },

  async removeTeamMember(teamId, employeeId) {
    return api.delete(`/api/labor/teams/${teamId}/members/${employeeId}`);
  },

  /**
   * Patrón activo del equipo en una fecha.
   * GET /api/labor/teams/:teamId/active-pattern?date=YYYY-MM-DD
   */
  async getTeamActivePattern(teamId, date) {
    const params = new URLSearchParams({ date: String(date) });
    return api.get(`/api/labor/teams/${teamId}/active-pattern?${params}`);
  },
};
